import { createApp } from 'vue';
//import HomePage from './components/HomePage.vue';
//import AboutPage from './components/AboutPage.vue';
import App from './App.vue'; // ��������һ��App.vue��Ϊ������
import router from './index.js';
//import App2 from './views/App2.vue';
import appmenu from './views/appmenu.vue';
import appfooter from './views/appfooter.vue';
 
// ������ʵ��
const app = createApp(App);
 
// ע��ҳ�����Ϊȫ�ֿ��õ����
//app.component('home-page', HomePage);
//app.component('about-page', AboutPage);
app.use(router);
app.mount('#app');
createApp(appmenu).mount('#appmenu');
createApp(appfooter).mount('#appfooter');